import usePermissions from "../../../hooks/usePermissions";

const { Trash2 } = require("lucide-react");
const { Button } = require("./Button");

const TableDeleteButton = ({ onClickHandler }) => {
  const permissions = usePermissions();
  const canDelete = permissions.canDelete();

  return (
    canDelete && (
      <Button variant="ghost" size="icon" onClick={onClickHandler}>
        <Trash2 className="w-4 h-4" />
      </Button>
    )
  );
};

export default TableDeleteButton;
